export const PaymentFrequency = Object.freeze({
  FORTNIGHTLY: 'Fortnightly',
  MONTHLY: 'Monthly',
  QUARTERLY: 'Quarterly',
  SEMI_ANNUAL: 'Semi-annual',
  ANNUAL: 'Annual',
});

export const PaymentFrequencySingleton = Object.freeze({
  FORTNIGHTLY: 'Fortnight',
  MONTHLY: 'Month',
  QUARTERLY: 'Quarter',
  SEMI_ANNUAL: '6 months',
  ANNUAL: 'year',
});
